import React, {useRef} from 'react';
import {useDispatch} from 'react-redux';

import {cancelPasswordReset, submitForgottenPasswordEmail} from 'modules/authentication/actions';

import AuthenticationContainer from 'components/Authentication/Steps/AuthenticationContainer';
import CancelAndContinueButtons from 'components/Authentication/Controls/CancelAndContinueButtons';
import InputField from 'components/Authentication/Controls/InputField';


export default function ForgottenPassword() {

    const dispatch = useDispatch();
    const inputRef = useRef(null);

    const continueAction = () => {
        if (inputRef.current.value === '' || !inputRef.current.value.includes('@')) {
            return;
        }

        dispatch(submitForgottenPasswordEmail(inputRef.current.value));
    };

    const cancelAction = () => {
        dispatch(cancelPasswordReset());
    };

    return <AuthenticationContainer title="Forgotten Password">
        <p>
            Please enter the email address into the text box below.
        </p>
        <p>
            If an account exists with your email address, you will be sent an email containing a code.
            If you don't receive this email, please check that the email address is correct and is the same as the one your user
            was set up with. Also check that the email has not been intercepted by spam filters.
        </p>
        <InputField label="Email Address" type="email" inputRef={inputRef} required={true}/>
        <CancelAndContinueButtons cancelAction={cancelAction} continueAction={continueAction}/>
    </AuthenticationContainer>;
}